import React from 'react'
import {
  saleEndedAndHasTickets,
  saleScheduledAndHasTickets,
  saleStartedAndHasTickets,
} from '@wix/wix-events-commons-statics'
import {GoesOnSaleLabel} from '../goes-on-sale-label'
import {SaleEndedBadge} from '../sale-ended-badge'
import {SoldOutLabel} from '../sold-out-label'
import s from './total-column.scss'
import {TotalColumnProps} from '.'

export const TotalColumn: React.FC<TotalColumnProps> = ({total, t, ticket}) => {
  const {limitPerCheckout, salePeriod} = ticket

  return (
    <>
      {saleStartedAndHasTickets(ticket) && (
        <div data-hook="total" role="cell" aria-label={`${t('ticketsPicker.subtotal')}: ${total}`}>
          {total}
        </div>
      )}
      {saleScheduledAndHasTickets(ticket) && (
        <GoesOnSaleLabel t={t} startDate={salePeriod.formattedSaleStartDate} className={s.goesOnSaleContainer} />
      )}
      <SoldOutLabel t={t} limit={limitPerCheckout} />
      {saleEndedAndHasTickets(ticket) && <SaleEndedBadge t={t} />}
    </>
  )
}
